import { Search, X } from "lucide-react";
import "./MobileFilterCard.css";

function MobileFilterCard({
  label,
  hint,
  placeholder,
  search,
  setSearch,
  countText,
  statusText,
  searchAriaLabel = label,
  className = "",
}) {
  return (
    <section className={`mobile-filter-card ${className}`.trim()} aria-label={label}>
      <div className="mobile-filter-card__heading">
        <div className="mobile-filter-card__copy">
          <strong>{label}</strong>
          {hint && <span>{hint}</span>}
        </div>
        {(countText != null || statusText) && (
          <div className="mobile-filter-card__badges">
            {countText != null && <span className="mobile-filter-card__count" aria-live="polite">{countText}</span>}
            {statusText && <span className="mobile-filter-card__status">{statusText}</span>}
          </div>
        )}
      </div>
      <div className="mobile-filter-card__search">
        <Search size={18} aria-hidden="true" />
        <input
          type="search"
          aria-label={searchAriaLabel}
          placeholder={placeholder}
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
        {search && (
          <button type="button" aria-label="Clear search" onClick={() => setSearch("")}>
            <X size={17} aria-hidden="true" />
          </button>
        )}
      </div>
    </section>
  );
}

export default MobileFilterCard;
